/**
 * Mega Menu Grouping Script v4.0
 * Agrupa elementos sin submenús en una sola columna para mejor organización
 */

(function() {
  'use strict';

  function groupMegaMenuElements() {
    const firstMegaMenu = document.querySelector('.m-menu__item--mega[data-index="0"]');
    if (!firstMegaMenu) {
      return;
    }

    const subMenuLevel1 = firstMegaMenu.querySelector('.m-sub-menu--level-1');
    if (!subMenuLevel1) {
      return;
    }

    const existingGrouped = subMenuLevel1.querySelectorAll('.mega-menu-grouped-column');
    if (existingGrouped.length > 0) {
      existingGrouped.forEach(element => element.remove());
    }

    const itemsWithoutSubmenu = subMenuLevel1.querySelectorAll('.m-sub-menu__item--level-1:not(:has(.m-mega-menu__column))');
    
    if (itemsWithoutSubmenu.length === 0) {
      return;
    }

    const groupedColumn = document.createElement('li');
    groupedColumn.className = 'mega-menu-grouped-column m-sub-menu__item--level-1';
    
    const internalList = document.createElement('ul');
    internalList.className = 'mega-menu-grouped-list';

    const elementsData = Array.from(itemsWithoutSubmenu).map(item => {
      const link = item.querySelector('.m-menu__link');
      return {
        href: link ? link.href : '#',
        text: link ? link.textContent.trim() : 'Sin título',
        element: item
      };
    });

    elementsData.forEach((data) => {
      const listItem = document.createElement('li');
      listItem.className = 'mega-menu-grouped-item';
      
      const link = document.createElement('a');
      link.href = data.href;
      link.className = 'm-menu__link mega-menu-grouped-link';
      link.textContent = data.text;
      
      listItem.appendChild(link);
      internalList.appendChild(listItem);
      
      data.element.remove();
    });

    groupedColumn.appendChild(internalList);

    const firstItemWithSubmenu = subMenuLevel1.querySelector('.m-sub-menu__item--level-1:has(.m-mega-menu__column)');
    if (firstItemWithSubmenu && firstItemWithSubmenu.nextElementSibling) {
      subMenuLevel1.insertBefore(groupedColumn, firstItemWithSubmenu.nextElementSibling);
    } else {
      subMenuLevel1.appendChild(groupedColumn);
    }

    window.megaMenuGroupingExecuted = true;
  }

  // Keep the desktop mega menu glued to the real bottom of the header.
  // The CSS uses `top: var(--mega-menu-top, 47px)`.
  //
  // The mega menu is `position: fixed`, but its ancestor `.m-header__wrapper`
  // has `will-change: transform`, which makes it the containing block for
  // fixed descendants. So `top` is measured from the WRAPPER's top edge, NOT
  // the viewport. We must therefore express the header bottom in that same
  // coordinate space: subtract the containing block's top. Using the raw
  // viewport-relative getBoundingClientRect().bottom double-counted the
  // wrapper offset (~103px) and left a gap below the nav.
  function findContainingBlock(el) {
    var n = el && el.parentElement;
    while (n && n !== document.documentElement) {
      var cs = getComputedStyle(n);
      if ((cs.transform && cs.transform !== 'none') ||
          (cs.willChange && /transform|perspective|filter/.test(cs.willChange)) ||
          (cs.filter && cs.filter !== 'none') ||
          (cs.perspective && cs.perspective !== 'none')) {
        return n;
      }
      n = n.parentElement;
    }
    return null; // no transformed ancestor -> fixed is viewport-relative
  }

  function updateMegaMenuTop() {
    var megaItem = document.querySelector('.m-menu__item--mega');
    var header = megaItem ? megaItem.closest('header') : document.querySelector('header');
    if (!header) return;
    var megaMenu = megaItem ? megaItem.querySelector('.m-mega-menu') : null;
    var cb = findContainingBlock(megaMenu || header);
    var cbTop = cb ? cb.getBoundingClientRect().top : 0;
    var top = Math.max(0, header.getBoundingClientRect().bottom - cbTop);
    document.documentElement.style.setProperty('--mega-menu-top', top + 'px');
  }

  window.addEventListener('scroll', updateMegaMenuTop, { passive: true });
  window.addEventListener('resize', updateMegaMenuTop, { passive: true });
  window.addEventListener('load', updateMegaMenuTop);
  document.addEventListener('mouseover', function (e) {
    if (e.target && e.target.closest && e.target.closest('.m-menu__item--mega')) {
      updateMegaMenuTop();
    }
  }, { passive: true });

  function boot() {
    groupMegaMenuElements();
    updateMegaMenuTop();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    setTimeout(boot, 50);
  }
})();
